package com.example.positionahead.data

import com.example.positionahead.model.AnalyticsWidgetType
import com.russhwolf.settings.Settings
import com.russhwolf.settings.set

class AnalyticsLayoutRepository(
    private val settings: Settings,
) {
    fun getWidgetOrder(): List<AnalyticsWidgetType> {
        val raw = settings.getStringOrNull(KEY_WIDGET_ORDER) ?: return AnalyticsWidgetType.defaultOrder
        val parsed = raw.split(",")
            .mapNotNull { AnalyticsWidgetType.fromId(it.trim()) }
        val missing = AnalyticsWidgetType.defaultOrder.filter { it !in parsed }
        return if (parsed.isEmpty()) {
            AnalyticsWidgetType.defaultOrder
        } else {
            parsed + missing
        }
    }

    fun saveWidgetOrder(order: List<AnalyticsWidgetType>) {
        settings[KEY_WIDGET_ORDER] = order.joinToString(",") { it.name }
    }

    fun resetWidgetOrder(): List<AnalyticsWidgetType> {
        saveWidgetOrder(AnalyticsWidgetType.defaultOrder)
        return AnalyticsWidgetType.defaultOrder
    }

    companion object {
        private const val KEY_WIDGET_ORDER = "analytics_widget_order"
    }
}
